import {initializeApp} from 'firebase/app';
import {connectAuthEmulator, getAuth, GoogleAuthProvider} from 'firebase/auth';
import {connectFirestoreEmulator, initializeFirestore} from 'firebase/firestore';
import {connectFunctionsEmulator, getFunctions} from 'firebase/functions';
import {getStorage} from 'firebase/storage';
import {env} from './env';

const firebaseApp = initializeApp(env.firebase);

export const firebaseAuth = getAuth(firebaseApp);
export const firebaseFirestore = initializeFirestore(firebaseApp, {
  ignoreUndefinedProperties: true,
});
export const firebaseStorage = getStorage(firebaseApp);
export const firebaseFunction = getFunctions(firebaseApp, 'europe-west2');

if (env.isDev) {
  console.info('using emulator');
  if (env.firebaseEmulator.auth) connectAuthEmulator(firebaseAuth, 'http://localhost:9099');
  if (env.firebaseEmulator.firestore) connectFirestoreEmulator(firebaseFirestore, 'localhost', 8080);
  if (env.firebaseEmulator.functions) connectFunctionsEmulator(firebaseFunction, 'localhost', 5001);
}

export const googleProvider = new GoogleAuthProvider();

export function getFirebaseFunction(path?: string) {
  if (env.isDev) {
    // @ts-ignore
    const s: string[] = [
      (firebaseFunction as any).emulatorOrigin as string,
      firebaseApp.options.projectId as string,
      firebaseFunction.region,
      ...(path ? [path] : []),
    ];
    return s.join('/');
  }
  // @ts-ignore
  // return `https://${firebaseFunction.region}-${firebaseApp.options.projectId as string}.cloudfunctions.net/${path}`;
  return `/${path}`;
}
